import WhiteTheme, { WhiteThemeContext } from './WhiteTheme'

export { WhiteThemeContext }
export default WhiteTheme
